import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const Hero = () => {
  return <section className="w-full bg-gradient-to-r from-blue-900 to-blue-700 text-white py-20" data-id="element-148">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-149">
        <div className="flex flex-col md:flex-row items-center" data-id="element-150">
          <div className="md:w-1/2 md:pr-10" data-id="element-151">
            <h1 className="text-4xl sm:text-5xl font-bold leading-tight mb-4" data-id="element-152">
              用科技驱动
              <br data-id="element-153" />
              <span className="text-blue-300" data-id="element-154">量化交易</span>未来
            </h1>
            <p className="text-lg sm:text-xl mb-8 text-blue-100" data-id="element-155">
              极客quant提供专业的量化交易策略，通过算法和人工智能技术，为您的投资带来稳定回报。
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-156">
              <button className="bg-white text-blue-900 hover:bg-blue-100 px-6 py-3 rounded-lg font-semibold flex items-center justify-center" data-id="element-157">
                免费咨询 <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-158" />
              </button>
              <button className="border border-white text-white hover:bg-blue-800 px-6 py-3 rounded-lg font-semibold" data-id="element-159">
                了解我们的策略
              </button>
            </div>
          </div>
          <div className="md:w-1/2 mt-10 md:mt-0" data-id="element-160">
            <div className="bg-blue-800 p-6 rounded-lg shadow-xl" data-id="element-161">
              <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80" alt="量化交易图表" className="rounded-lg w-full" data-id="element-162" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};